export const GA_ID = "G-5P2CR2VLGJ";

let loaded = false;

export function loadAnalytics() {
  if (loaded || localStorage.getItem("ga_consent") !== "granted") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function gtagEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
}

const TESTID_EVENTS = {
  "header-cta-button": "cta_book_consultation",
  "mobile-cta-button": "cta_book_consultation",
  "hero-cta-button": "cta_book_consultation",
  "cta-band-book-button": "cta_book_consultation",
  "purtier-cta-button": "cta_book_consultation",
  "how-to-buy-cta": "cta_book_consultation",
  "blog-empty-cta": "cta_book_consultation",
  "cta-phone-button": "contact_phone",
  "contact-phone-link": "contact_phone",
  "footer-phone-link": "contact_phone",
  "cta-band-phone-link": "contact_phone",
  "floating-phone-button": "contact_phone",
  "floating-whatsapp-button": "contact_whatsapp",
  "floating-viber-button": "contact_viber",
  "cta-band-viber-link": "contact_viber",
  "cta-band-whatsapp-link": "contact_whatsapp",
  "cta-whatsapp-button": "contact_whatsapp",
  "contact-whatsapp-link": "contact_whatsapp",
  "cta-viber-button": "contact_viber",
  "contact-viber-link": "contact_viber",
  "contact-email-link": "contact_email",
  "footer-email-link": "contact_email",
  "blog-post-external-button": "press_article_click",
  "contact-linkedin-link": "contact_linkedin",
  "footer-linkedin-link": "contact_linkedin",
};

export function trackClick(target) {
  const el = target.closest?.("[data-testid]");
  if (!el) return;
  const event = TESTID_EVENTS[el.dataset.testid];
  if (event) gtagEvent(event, { element: el.dataset.testid, page: window.location.pathname });
}

export function initScrollDepth() {
  const marks = [25, 50, 75, 90];
  const fired = new Set();
  const onScroll = () => {
    const doc = document.documentElement;
    const pct = ((window.scrollY + window.innerHeight) / doc.scrollHeight) * 100;
    for (const m of marks) {
      if (pct >= m && !fired.has(m)) {
        fired.add(m);
        gtagEvent("scroll_depth", { percent: m, page: window.location.pathname });
      }
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
}
